import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MATERIAL_ICON_SVG } from '@constants/MaterialIconSvg';

@Injectable({
  providedIn: 'root'
})
export class MaterialIconRegistryService {

  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
  }

  setUp() {
    MATERIAL_ICON_SVG.forEach((x) => {
      this.matIconRegistry.addSvgIcon(x.icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(x.path));
    });
  }
}
